import { render } from "./LueckeInfo.vue?vue&type=template&id=31677302"
import script from "./LueckeInfo.vue?vue&type=script&lang=js"
export * from "./LueckeInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__